/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeploymentStepLogDto } from './DeploymentStepLogDto';
import {
    DeploymentStepLogDtoFromJSON,
    DeploymentStepLogDtoFromJSONTyped,
    DeploymentStepLogDtoToJSON,
} from './DeploymentStepLogDto';

/**
 * 
 * @export
 * @interface DeploymentSubStepDto
 */
export interface DeploymentSubStepDto {
    /**
     * The id of the sub-step.
     * @type {number}
     * @memberof DeploymentSubStepDto
     */
    id: number;
    /**
     * The name of the sub-step.
     * @type {string}
     * @memberof DeploymentSubStepDto
     */
    name: string;
    /**
     * The status of the sub-step.
     * @type {string}
     * @memberof DeploymentSubStepDto
     */
    status: DeploymentSubStepDtoStatusEnum;
    /**
     * The error, when the sub-step failed.
     * @type {string}
     * @memberof DeploymentSubStepDto
     */
    error: string | null;
    /**
     * The timestamped log lines reported for this sub-step.
     * @type {Array<DeploymentStepLogDto>}
     * @memberof DeploymentSubStepDto
     */
    logs: Array<DeploymentStepLogDto>;
    /**
     * When the sub-step was started.
     * @type {Date}
     * @memberof DeploymentSubStepDto
     */
    startedAt: Date | null;
    /**
     * When the sub-step was completed or failed.
     * @type {Date}
     * @memberof DeploymentSubStepDto
     */
    completedAt: Date | null;
}


/**
 * @export
 */
export const DeploymentSubStepDtoStatusEnum = {
    Pending: 'Pending',
    Running: 'Running',
    Completed: 'Completed',
    Failed: 'Failed'
} as const;
export type DeploymentSubStepDtoStatusEnum = typeof DeploymentSubStepDtoStatusEnum[keyof typeof DeploymentSubStepDtoStatusEnum];


/**
 * Check if a given object implements the DeploymentSubStepDto interface.
 */
export function instanceOfDeploymentSubStepDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "logs" in value;
    isInstance = isInstance && "startedAt" in value;
    isInstance = isInstance && "completedAt" in value;

    return isInstance;
}

export function DeploymentSubStepDtoFromJSON(json: any): DeploymentSubStepDto {
    return DeploymentSubStepDtoFromJSONTyped(json, false);
}

export function DeploymentSubStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentSubStepDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': json['status'],
        'error': json['error'],
        'logs': ((json['logs'] as Array<any>).map(DeploymentStepLogDtoFromJSON)),
        'startedAt': (json['startedAt'] === null ? null : new Date(json['startedAt'])),
        'completedAt': (json['completedAt'] === null ? null : new Date(json['completedAt'])),
    };
}

export function DeploymentSubStepDtoToJSON(value?: DeploymentSubStepDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'status': value.status,
        'error': value.error,
        'logs': ((value.logs as Array<any>).map(DeploymentStepLogDtoToJSON)),
        'startedAt': (value.startedAt === null ? null : value.startedAt.toISOString()),
        'completedAt': (value.completedAt === null ? null : value.completedAt.toISOString()),
    };
}

